<template>
  <div class="project-management">
    <h1>Gestion des projets</h1>
    <div v-if="!selectedProject">
      <div v-for="group in groupedProjects" :key="group.referential_id" class="referential-group">
        <h2 class="referential-group-title">{{ group.referential_title }} [{{ getReferentialStatusLabel(group) }}]</h2>
        <div>
          <div
            v-for="project in group.projects"
            :key="project.project_id"
            class="project-item"
            @click="selectProject(project)"
          >
            <div class="title-col">{{ project.title }}</div>
            <div class="description-col">{{ project.description }}</div>
            <div class="status-col">{{ getStatusLabel(project.status) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- Project detail/access management, similar to ProjectAccess -->
      <ProjectAccess :project="selectedProject" @back="deselectProject" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ProjectAccess from './ProjectAccess.vue'

export default {
  name: "ProjectManagement",
  components: { ProjectAccess },
  data() {
    return {
      selectedProject: null,
      referentialStatusOptions:[
            {value:"", label:"Statut"},
            {value:"EDITING", label:"Edition"},
            {value:"RELEASE", label:"Production"},
            {value:"RELEASEUSED", label: "Production (utilisé)"},
            {value:"ARCHIVE", label:"Archivé"}
        ],
        loading: false,
    }
  },
  computed: {
    ...mapState("project", ["projectData"]),
    ...mapState("referential", ["referentialData", "projectStatusByReferential"]),
    ...mapGetters("referential", ["getProjectsInValidationList", "getProjectsValidatedList", "getProjectsInArchivedList", "usersWithoutProjectAccess"]),
    ...mapGetters("project", ["formatDate"]),
    groupedProjects() {
        const projects = this.projectStatusByReferential
        if (!projects || Object.keys(projects).length === 0) {
            return []
        }
        const groups = []
        Object.entries(projects).forEach(([refId, projectArray]) => {
            // Find referential title if needed
            const ref = this.referentialData.find(r => r.referentiel_id == refId)
            const filteredProjects = projectArray.filter(p => p.status !== "EDITING")
            if(filteredProjects.length === 0) {
                return; // Skip empty groups
            }
            groups.push({
                referential_id: refId,
                referential_title: ref ? ref.title : `Référentiel #${refId}`,
                referential_status: ref ? ref.status : 'Inconnu',
                projects: filteredProjects
            })
        })
        return groups
    },
    getStatusLabel() {
      // You can import or reuse the getStatusLabel method from ProjectEditor
        return status => {
            const options = [
            { value: '', label: 'Statut' },
            { value: 'EDITING', label: 'Edition' },
            { value: 'VALIDATION', label: 'En validation' },
            { value: 'VALIDATED', label: 'Validé' },
            { value: 'ARCHIVE', label: 'Archivé' }
            ];
            const option = options.find(opt => opt.value === status);
            return option ? option.label : status;
        }
    }
  },
  async mounted() {
    this.$store.commit("project/loadingMutation", true);
    if(!this.referentialData || this.referentialData.length === 0) {
        await this.$store.dispatch("referential/fetchReferentialList")
            .catch(error => console.error("Erreur :", error))
    }
    this.$store.commit("project/loadingMutation", false);
    
    this.$store.commit("project/selectProjectMutation", 0)
    //console.log("ProjectManagement component mounted");
    //console.log("projectlist thingy", this.projectStatusByReferential)
  },
  methods: {
    selectProject(project) {
      this.selectedProject = project;
    },
    deselectProject() {
      this.selectedProject = null;
    },
    getReferentialStatusLabel(referential) {
        //console.log("Getting status label for referential:", referential)
        //console.log("Referential status:", referential.referential_status)
        //console.log("Status options:", this.referentialStatusOptions)
        let status = referential.referential_status
        if (!this.referentialStatusOptions) {
            return status
        }
        if(this.referentialStatusOptions.length === 0) {
            return status
        }
        // if(status === "RELEASE") {
        //     status = "RELEASEUSED"
        // }
        const optionValue = this.referentialStatusOptions.find(opt => opt.value === status);
        return optionValue ? optionValue.label : status;
    },
  }
}
</script>


<style scoped>
/* grid */
.project-header,
.project-item,
.project-filter{
  display: grid;
  grid-template-columns: 15% 35% 16% 17% 18%  ;
  /* grid-template-columns: 9% 39% 0% 21% 15% 16%; */
  width: 100%;
  align-items: center;
}
.project-filter{
  grid-template-columns: 60% 40%;
}

/* .project-owner {
    border-left: 7px solid #979797;
}
.project-owner-shared {
    border-left: 7px solid #aebde7;
}
.project-collaborator {
    border-left: 7px solid #f58a93;
} */

.project-header {
  grid-template-columns:15% 35% 16% 17% 17%;
  font-weight: bold;
  padding: 12px 15px;
  border-radius: var(--border-radius);
  margin-bottom: 2vh;
  padding: 20px 14px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); */
  overflow: hidden;
  top: 0;
}

.project-header:hover, 
.project-header:hover .header-filter-select {
    background-color: var(--hover-bg);
    transition: all 0.5s ease-out;
    outline: none;
}

.project-header > div {
  cursor: pointer;
  user-select: none;
  position: relative;
}

.project-header > div:hover {
  color: var(--primary-color);
  transition: var(--transition);
}

.project-header > div i {
  margin-left: 5px;
}

.status-cols, .date-cols, .user-cols {
  display: grid;
  grid-template-columns: 33% 44% 23%;
  width: 100%;
}

/* column styles */
.id-col, .title-col, .description-col,.referential-col, .status-col, .status2-col, .date-col, .user-col, .actions-col {
  padding: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.project-item:has(.actions-col) {
    grid-template-columns: 25% 50% 25% ;
    background-color: none;
}

.id-col {
  text-align: center;
  font-weight: 500;
}

/* filter style */
.project-filter {
  padding: 12px 15px;
  margin-bottom: 15px;
  background-color: #f8f9fa;
  border-radius: var(--border-radius);
  border: 1px solid var(--border-color);
}

.filter-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: var(--border-radius);
  font-size: 14px;
  transition: border-color 0.2s;
}

.filter-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px var(--primary-light);
}

.filter-select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: var(--border-radius);
  background-color: white;
  cursor: pointer;
  width: 100%;
}

/* Status header select */
.status-header {
  display: flex;
  align-items: center;
  position: relative;
}

.header-filter-select {
    padding: 2px 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    width: 130px;
    height: 35px;
    border: none;
}

/* project list */
.project-list {
  /* border: 1px solid var(--border-color);
  background-color: #f8f9fa; */
  padding:8px;
  border-radius: var(--border-radius);
  overflow: hidden;
}

.project-item {
  padding: 20px 14px;
  border-radius: 12px;
  cursor: pointer;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  border: 1.7px solid var(--project-color);
  border-left: 1.7px solid var(--project-color);
}

.project-item:hover {
  background-color: var(--hover-bg);
  /* transition: color 0.4s linear; */
  border: 1.7px solid var(--project-color);
  transition: all 0.13s ease-out ;
  border-left: var(--border-value) solid var(--project-color);
}
/* 
.project-detail-container {
  margin: 20px 0;
  padding: 20px;
  background-color: white;
  border-radius: var(--border-radius);
  border: 1px solid var(--border-color);
}
 */
/* buttons */
.action-buttons, .filter-toggle {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.back-button, .create-button {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border-radius: var(--border-radius);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.back-button {
  background-color: #f8f9fa;
  color: var(--text-color);
  /* border: 1px solid var(--border-color); */
}
.back-button:hover{
    background-color: #e9ecef;
}
.create-button:hover {
  background-color: var(--hover-bg);
  color:var(--text-color);
  transition: var(--transition);
}

.create-button {
  background-color: var(--primary-color);
  color: white;
}


.filter-toggle-btn{
  background-color: var(--primary-light);
  color: var(--primary-color);
  border: none;
  font-size: 1rem;
}

.filter-toggle-btn:hover{
  background-color: var(--primary-color);
  color: var(--bg-color);
  border: var(--bg-color);
}

.btn {
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
}

.btn-icon {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 18px;
  padding: 0;
  margin: 0 2px;
  background-color: var(--hover-bg);
  color: var(--text-color);
}

.btn-icon:hover {
  color: var(--primary-color);
}

.actions-col {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 3vw;
  gap: 2px;
}

.project-item.locked {
  opacity: 0.6;
}

.project-code-actions{
    width: 100%;
    display: flex;
    text-align: center;
    margin: auto;
    justify-content: center;
}

.project-code-button{
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border-radius: var(--border-radius);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  background-color: var(--hover-bg);
  color: var(--text-color);
}

.project-code-button:hover{
  background-color:#e3e3e3;
  color: #2d2d2d;
  transition: var(--transition);
}

.project-header-code {
    display: flex;
    align-items: center;
    gap: 1rem; 
    padding: 1rem;
    border-radius: 8px;
    /* max-width: 24.4vw; */
    max-width: 32.4vw;
    /* margin: auto; */
    text-align: center;
}

.project-insert {
    flex-grow: 1;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 0.75rem 1rem;
}

.project-answer {
    padding: 0.75rem 1rem;
    border-radius: 6px;
    font-weight: 500;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
}

.referential-group {
  margin-bottom: 30px;
}

.referential-group-title {
  font-size: 1.5em;
  font-weight: bold;
  color: var(--primary-color);
  padding-bottom: 10px;
  border-bottom: 2px solid var(--primary-light);
  margin-bottom: 15px;
}

:deep(.multiselect__option--selected.multiselect__option--highlight, .multiselect__option--selected.multiselect__option--highlight::after) {
  /* background: #ff6a6a; */
  color: #fff;
}
:deep(.multiselect__option--highlight, .multiselect__option--highlight::after) {
  /* background: var(--primary-color); */
  outline: none;
  color: #5e4545;
}
:deep(.multiselect__content-wrapper){
  min-width: 100%;
}

/* :deep(.multiselect__tags){
  min-width: 324%;
} */
:deep(.multiselect__option--selected) {
  background: #f3f3f3;
  color: #35495e;
  font-weight: bold;
}


.status-col {
    overflow: hidden;
}

#element-to-print {
  background-color: white; /* Fond blanc pour être sûr */
  color: black; /* Texte noir par défaut */
}

/* On force des couleurs "en dur" pour les titres et textes importants */
#element-to-print .project-title {
  font-size: 18px;
  font-weight: bold;
  color: #1a202c; /* Remplacez var(--text-color) par une couleur hexadécimale */
}

#element-to-print .project-reference {
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
  background-color: #f7fafc;
  border: 1px solid #e2e8f0;
}

#element-to-print .q-description {
    color: #2d3748;
}

/* Assurez-vous que les bordures utilisent aussi des couleurs fixes */
#element-to-print .project-container {
    border: 1px solid #cbd5e0; /* Remplacez var(--project-border-color) */
}
</style>